import { render, staticRenderFns } from "./batch-update-dialog.vue?vue&type=template&id=3a60841c&scoped=true&"
import script from "./batch-update-dialog.vue?vue&type=script&lang=js&"
export * from "./batch-update-dialog.vue?vue&type=script&lang=js&"
import style0 from "./batch-update-dialog.vue?vue&type=style&index=0&id=3a60841c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60841c",
  null
  
)

export default component.exports